import { getLocalStorage, setLocalStorage } from './Utils';

const GATING_STORAGE_KEY = 'live_tv_gating';

export const getGatingData = () => {
    const data = getLocalStorage(GATING_STORAGE_KEY);
    try {
        return data ? JSON.parse(data) : {};
    } catch (e) {
        return {};
    }
};

export const getWatchedTime = (assetId: string) => {
    const data = getGatingData();
    return data[assetId] || 0;
};

export const updateWatchedTime = (assetId: string, limitSeconds: number, timeInSeconds: number = 1) => {
    const data = getGatingData();
    const currentTime = data[assetId] || 0;
    
    if (currentTime >= limitSeconds) {
        return limitSeconds;
    }

    const newTime = currentTime + timeInSeconds;
    data[assetId] = newTime > limitSeconds ? limitSeconds : newTime;
    
    setLocalStorage(GATING_STORAGE_KEY, JSON.stringify(data));
    return data[assetId];
};

export const checkGating = (assetId: string, limitSeconds: number) => {
    const watchedTime = getWatchedTime(assetId);
    return watchedTime >= limitSeconds;
};

export const getRemainingTime = (assetId: string, limitSeconds: number) => {
    const watchedTime = getWatchedTime(assetId);
    return Math.max(0, limitSeconds - watchedTime);
};

export const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};
